import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert"
import { EXPORT_ENQUEUED_MESSAGE } from "helpers/sf_constants"

export const showExportEnqueuedToast = ({ reportExportsAvailable = false } = {}) => {
  if (!reportExportsAvailable) {
    return ToastAlert.fire({
      icon: ToastAlertIconType.OK,
      title: EXPORT_ENQUEUED_MESSAGE,
    })
  }

  return ToastAlert.fire({
    icon: ToastAlertIconType.OK,
    title: "Report generation started.",
    html: `We'll email you when it's ready, or track it under <span class="text-sfpink fw-bold">Activity → Report Exports</span>.`,
  })
}
